import {ModalContext} from 'app/app';
import axios from 'axios';
import {FieldInput} from 'components/fieldInput';
import {AuthContext, ViewContext} from 'components/lib';
import {Form, Formik} from 'formik';
import {Fragment, useContext, useState} from 'react';
import * as Yup from 'yup';
import Loader from './images/loader.gif';
import styles from './styles.module.scss';

export function UserModal(props) {
  const context = useContext(ViewContext);
  const {modal, setModal} = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const Auth = useContext(AuthContext);

  const noSpecialCharactersRegex = /^[A-Za-z0-9 ]*$/;

  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .required('This field is required!')
      .matches(
        noSpecialCharactersRegex,
        'First Name must not contain special characters'
      ),
    last_name: Yup.string()
      .required('This field is required!')
      .matches(
        noSpecialCharactersRegex,
        'Last Name must not contain special characters'
      ),
    email: Yup.string().email().required('This field is required!'),
  });

  return (
    <Fragment>
      {modal.name === 'user_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Invite User</div>
              <div className={styles.line}/>
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  email: '',
                  agency: Auth.user.account_id,
                }}
                onSubmit={async (values) => {
                  setLoading(true);
                  const first_name = values.first_name.trim();
                  const last_name = values.last_name.trim();
                  const email = values.email.trim();

                  const res = await axios.get(
                    '/api/user/search?page=1&search=' + email
                  );

                  if (res.data.data.data.length === 0) {
                    await axios
                      .post('/api/invite', {
                        first_name: first_name,
                        last_name: last_name,
                        email: email,
                        agency: Auth.user.account_id,
                        type: 'user',
                      })
                      .then((r) => {
                        setLoading(false);
                        setModal('');

                        context.notification.show(
                          'Invite sent!',
                          'success',
                          true,
                          'toast',
                          'check-circle'
                        );
                      })
                      .catch((error) => {
                        console.log(error);

                        setLoading(false);
                        setModal('');
                      });
                  } else {
                    setLoading(false);
                    setModal('');

                    context.notification.show(
                      'That email is already registered',
                      'error',
                      true,
                      'toast',
                      'check-circle'
                    );
                  }
                }}
              >
                {({
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    submitForm,
                  }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div
                        className={styles.fieldRow}
                        style={{paddingBottom: 0}}
                      >
                        <FieldInput
                          id="first_name"
                          type="text"
                          label="First name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.first_name}
                          touched={touched.first_name}
                        />
                        <FieldInput
                          id="last_name"
                          type="text"
                          label="Last name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.last_name}
                          touched={touched.last_name}
                        />
                      </div>
                      <div
                        className={styles.fieldRow}
                        style={{paddingBottom: 0}}
                      >
                        <FieldInput
                          id="email"
                          type="text"
                          label="Email"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.email}
                          touched={touched.email}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{justifyContent: 'flex-end'}}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={submitForm}
                        >
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Invite'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
